<div class="st-form">
  <app-st-impersonation-floating-banner [impersonatedEmail]="this.impersonatedEmail"
                                        [username]="this.username"
                                        [roleName]="this.consultantRoleName"
                                        (exitViewAs)="this.onExitViewAs($event)"
  >

  </app-st-impersonation-floating-banner>
</div>
<app-st-banner [idVal]="'banner-id'" [breadCrumbs]="this.breadCrumbs"
               [hasElementTags]="true" [elementTags]="this.elementTags" [requiresSignOutButton]="true"
></app-st-banner>
<br><br><br><br><br><br>
<div class="container-xxl">
  <div *ngIf="showPageErrorMessages" class="container st-form text-danger" #goUp>
    <app-st-span [inputVal]="'An error has occurred: '"></app-st-span>
    <div *ngFor="let errorMsg of pageErrorMessages" class="alert alert-danger" role="alert">
      <b>{{errorMsg.field}}:</b> {{errorMsg.detail}}
    </div>
    <br>
  </div>
  <div *ngIf="this.showPageSuccessMessages" class="container st-form text-success" #goUp>
    <div *ngFor="let successMsg of pageSuccessMessages" class="alert alert-success" role="alert">
      <b>{{successMsg.field}}:</b> {{successMsg.detail}}
    </div>
    <br>
  </div>
  <div class="container st-form">
    <div class="col2 d-grid gap-2 d-md-flex justify-content-md-end align-items-end">
      <app-st-button [idVal]="'top-back-button-id'" [label]="'Back'" [primary]="true"
                     (click)="this.onBack()"></app-st-button>
      <app-st-button-pdf [idVal]="'top-export-pdf-button-id'" [label]="'Export As PDF'"
                         (click)="this.generateSearchablePdf()"></app-st-button-pdf>
    </div>
    <app-st-header-title [idVal]="'donor-info-id'" [inputVal]="'Donor Information'"></app-st-header-title>

    <div class="row pt-2 webtext-black">
      <div class="col">
        <span><strong>Organization: </strong></span><span>{{nonprofitDonorFullAttr['companyName']}}</span>
      </div>
    </div>
    <div class="row pt-2 webtext-black">
      <div class="col">
        <span><strong>Ein: </strong></span><span>{{this.formatEin(nonprofitDonorFullAttr['ein'])}}</span>
      </div>
    </div>
    <div class="row pt-2 webtext-black">
      <div class="col">
        <span><strong>Phone Number: </strong></span><span>{{this.formatPhoneNumber(nonprofitDonorFullAttr['phoneNumber'])}}</span>
      </div>
    </div>
    <!--
    <div class="row pt-2 webtext-black">
      <div class="col">
        <span><strong>Email: </strong></span><span>{{nonprofitDonorFullAttr['email']}}</span>
      </div>
    </div>
    -->
    <div class="row pt-2 webtext-black">
      <div class="col">
        <span><strong>Website URL: </strong></span><a *ngIf="nonprofitDonorFullAttr['websiteURL'] && (nonprofitDonorFullAttr['websiteURL'].startsWith('http') || nonprofitDonorFullAttr['websiteURL'].startsWith('www.') || nonprofitDonorFullAttr['websiteURL'].includes('.org') || nonprofitDonorFullAttr['websiteURL'].includes('.com') || nonprofitDonorFullAttr['websiteURL'].includes('.net'))" target="_blank" href="{{nonprofitDonorFullAttr['websiteURL']}}">{{nonprofitDonorFullAttr['websiteURL']}}</a>
        <span *ngIf="!nonprofitDonorFullAttr['websiteURL'] || (!nonprofitDonorFullAttr['websiteURL'].startsWith('http') && !nonprofitDonorFullAttr['websiteURL'].startsWith('www.') && !nonprofitDonorFullAttr['websiteURL'].includes('.org') && !nonprofitDonorFullAttr['websiteURL'].includes('.com') && !nonprofitDonorFullAttr['websiteURL'].includes('.net'))">No Website Available - We Recommend Calling</span>
      </div>
    </div>
    <!--
    <div class="row pt-2 webtext-black">
      <div class="col">
        <span><strong>Twitter Profile: </strong></span><a *ngIf="nonprofitDonorFullAttr['twitterProfileURL']" target="_blank" href="{{nonprofitDonorFullAttr['twitterProfileURL']}}">{{nonprofitDonorFullAttr['twitterProfileURL']}}</a><span *ngIf="!nonprofitDonorFullAttr['twitterProfileURL']">N/A</span>
      </div>
    </div>
    <div class="row pt-2 webtext-black">
      <div class="col">
        <span><strong>Facebook Profile: </strong></span><a *ngIf="nonprofitDonorFullAttr['facebookProfileURL']" target="_blank" href="{{nonprofitDonorFullAttr['facebookProfileURL']}}">{{nonprofitDonorFullAttr['facebookProfileURL']}}</a><span *ngIf="!nonprofitDonorFullAttr['facebookProfileURL']">N/A</span>
      </div>
    </div>
    <div class="row pt-2 webtext-black">
      <div class="col">
        <span><strong>LinkedIn Profile: </strong></span><a *ngIf="nonprofitDonorFullAttr['linkedInProfileURL']" target="_blank" href="{{nonprofitDonorFullAttr['linkedInProfileURL']}}">{{nonprofitDonorFullAttr['linkedInProfileURL']}}</a><span *ngIf="!nonprofitDonorFullAttr['linkedInProfileURL']">N/A</span>
      </div>
    </div>
    <div class="row pt-2 webtext-black">
      <div class="col">
        <span><strong>Instagram Profile: </strong></span><a *ngIf="nonprofitDonorFullAttr['instagramProfileURL']" target="_blank" href="{{nonprofitDonorFullAttr['instagramProfileURL']}}">{{nonprofitDonorFullAttr['instagramProfileURL']}}</a><span *ngIf="!nonprofitDonorFullAttr['instagramProfileURL']">N/A</span>
      </div>
    </div>
    <div class="row pt-2 webtext-black">
      <div class="col">
        <span><strong>Youtube Profile: </strong></span><a *ngIf="nonprofitDonorFullAttr['youtubeProfileURL']" target="_blank" href="{{nonprofitDonorFullAttr['youtubeProfileURL']}}">{{nonprofitDonorFullAttr['youtubeProfileURL']}}</a><span *ngIf="!nonprofitDonorFullAttr['youtubeProfileURL']">N/A</span>
      </div>
    </div>
    <div class="row pt-2 webtext-black">
      <div class="col">
        <span><strong>Threads Profile: </strong></span><a *ngIf="nonprofitDonorFullAttr['threadsProfileURL']" target="_blank" href="{{nonprofitDonorFullAttr['threadsProfileURL']}}">{{nonprofitDonorFullAttr['threadsProfileURL']}}</a><span *ngIf="!nonprofitDonorFullAttr['threadsProfileURL']">N/A</span>
      </div>
    </div>
    -->
    <br>
    <div class="row pt-2 webtext-black">
      <div class="col">
        <span><strong>Address (Based on Latest Tax Return): </strong></span><br>
        <div *ngIf="nonprofitDonorFullAttr['taxFilingStreetAddress']">
          <span>{{nonprofitDonorFullAttr['taxFilingStreetAddress']}}</span><br>
          <span>{{nonprofitDonorFullAttr['taxFilingCity']}}, {{nonprofitDonorFullAttr['taxFilingState']}} {{this.formatZipCode(nonprofitDonorFullAttr['taxFilingZipCode'])}} USA</span><br>
        </div>
        <div *ngIf="!nonprofitDonorFullAttr['taxFilingStreetAddress']">
          <span>N/A</span><br>
        </div>
      </div>
    </div>

    <br>
    <div class="row pt-2 webtext-black">
      <div class="col">
        <span><strong>Other Known Address: </strong></span><br>
        <div *ngIf="nonprofitDonorFullAttr['streetAddress']">
          <span>{{nonprofitDonorFullAttr['streetAddress']}}</span><br>
          <span>{{nonprofitDonorFullAttr['city']}}, {{nonprofitDonorFullAttr['state']}} {{formatZipCode(nonprofitDonorFullAttr['zipCode'])}} USA</span><br>
        </div>
        <div *ngIf="!nonprofitDonorFullAttr['streetAddress']">
          <span>N/A</span><br>
        </div>
      </div>
    </div>
    <br>
    <app-st-header-title [idVal]="'donor-characteristics-id'" [inputVal]="'Donor Characteristics:'"></app-st-header-title>
    <div class="row pt-2 webtext-black">
      <div class="col">
        <span><strong>Organization Code: </strong> {{organizationCode}}</span>
      </div>
    </div>
    <div class="row pt-2 webtext-black">
      <div class="col">
        <span><strong>Foundation Code: </strong> {{foundationCode}}</span>
      </div>
    </div>
    <div class="row pt-2 webtext-black">
      <div class="col">
        <span><strong>NTEE Parent Code: </strong> {{nteeParentCode}}</span>
      </div>
    </div>
    <div class="row pt-2 webtext-black">
      <div class="col">
        <span><strong>NTEE Code: </strong> {{nteeCode}}</span>
      </div>
    </div>
    <div class="row pt-2 webtext-black">
      <div class="col">
        <span><strong>Established Year: </strong> {{establishedYear}}</span>
      </div>
    </div>
    <div class="row pt-2 webtext-black">
      <div class="col">
        <span><strong>Return Type Code: </strong> {{returnTypeCode}}</span>
      </div>
    </div>
    <br>
    <br>
    <app-st-header-title [idVal]="'donor-causes-id'" [inputVal]="'Donor Causes:'"></app-st-header-title>
    <br>
    <div>
      <button id="'view-causes-button-id'" class="accordion webtext-black" (click)="this.toggleViewCausePanel()"><b>See All Causes (Click to Expand)</b>  <b> - </b></button>
    </div>
    <div *ngIf="viewCausePanelVisible" class="panel">
      <div class="accordion-body">
        <div class="webtext-black">
          <br>
          <ul>
            <li *ngFor="let causeRow of this.causesDonatedTo">{{causeRow}}</li>
            <!--<li class="seeMoreLess" (click)="this.toggleViewCausePanel()"><i><b>See Less</b></i></li>-->
            <li>
              <div>
                <app-st-button *ngIf="this.viewCausePanelVisible" [idVal]="'see-less-cause-button-id'" [label]="'^ See Less'" [primary]="true"
                             (click)="this.toggleViewCausePanel()"></app-st-button>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div *ngIf="!viewCausePanelVisible" class="panel">
      <div class="accordion-body">
        <div class="webtext-black">
          <br>
          <ul>
            <li *ngFor="let causeRow of this.causesDonatedToPreview">{{causeRow}}</li>
            <!--<li class="seeMoreLess" (click)="this.toggleViewCausePanel()"><i><b>See All</b></i></li>-->
            <li>
              <div>
                <app-st-button *ngIf="!this.viewCausePanelVisible" [idVal]="'see-all-cause-button-id'" [label]="'^ See All'" [primary]="true"
                               (click)="this.toggleViewCausePanel()"></app-st-button>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <br>
    <br>
    <app-st-header-title [idVal]="'donor-finances-id'" [inputVal]="'Donor Finances Summary:'"></app-st-header-title>
    <br>
    <div *ngFor="let row of this.companyFinancialsByYear">
      <div>
        <button id="'total-assets-button-'+ {{row['taxYear']}} +'-id'" class="accordion webtext-black" (click)="this.toggleCompanyFinancialsPanel(row)"><b>Donor Financials for {{row['taxYear']}} </b><b *ngIf="!row['visible']"> + </b><b *ngIf="row['visible']"> - </b></button>
      </div>
      <div *ngIf="row['visible']" class="panel">
        <div class="accordion-body">
          <br>
          <app-st-header-title [inputVal]="'Donor Financials for ' + row.taxYear"></app-st-header-title>
          <div class="row pt-2 webtext-black">
            <div class="col">
              <span><strong>Tax Year: </strong></span><span>{{row['taxYear']}}</span>
            </div>
          </div>
          <div class="row pt-2 webtext-black">
            <div class="col">
              <span><strong>Total Revenue: </strong></span><span>{{row['totalRevenueFormatted']}} USD</span>
            </div>
          </div>
          <div class="row pt-2 webtext-black">
            <div class="col">
              <span><strong>Total Expenses: </strong></span><span>{{row['totalExpensesFormatted']}} USD</span>
            </div>
          </div>
          <div class="row pt-2 webtext-black">
            <div class="col">
              <span><strong>Total Assets: </strong></span><span>{{row['totalAssetsFormatted']}} USD</span>
            </div>
          </div>
          <br>
          <app-st-header-title [idVal]="'donor-key-staff-id'" [inputVal]="'Key Donors, Directors, and Staff'"></app-st-header-title>
          <table class="table table-striped webtext-black">
            <thead>
            <tr>
              <th scope="col">Name</th>
              <th scope="col">Title</th>
            </tr>
            </thead>
            <tbody>
            <tr *ngFor="let keyEmployee of row['keyEmployeesList']">
              <td>{{keyEmployee['personName']}}</td>
              <td>{{keyEmployee['titleTxt']}}</td>
            </tr>
            </tbody>
          </table>
          <br>
          <div>
            <app-st-button *ngIf="row['visible']" [idVal]="'see-less-finances-button-id'" [label]="'^ See Less'" [primary]="true"
                           (click)="this.toggleCompanyFinancialsPanel(row)"></app-st-button>
          </div>
        </div>
      </div>
      <br>
    </div>
    <br>
    <app-st-button-back-to-top></app-st-button-back-to-top>
    <br><br>
    <app-st-header-title [idVal]="'tax-returns-id'" [inputVal]="'Tax Return PDFs By Year'"></app-st-header-title>
    <table class="table table-striped webtext-black">
      <thead>
      <tr>
        <th scope="col">Tax Year</th>
        <th scope="col">Tax Return URL</th>
      </tr>
      </thead>
      <tbody>
      <tr *ngFor="let pdfRow of this.companyPDFsByYear">
        <td>{{pdfRow['taxYear']}}</td>
        <td><a target="_blank" href="{{pdfRow['url']}}">{{pdfRow['url']}}</a></td>
      </tr>
      </tbody>
    </table>
    <br>
    <app-st-button-back-to-top></app-st-button-back-to-top>
    <br><br>
    <app-st-header-title [idVal]="'donor-recipients-id'" [inputVal]="'Grants Donated to Recipients for ' + this.donatedToRecipientsTaxYear"></app-st-header-title>
    <br>
    <app-st-pagination2 [idVal]="'donated-to-recipients-pagination-id'" [collectionSize]="this.donatedToRecipientsCollectionSize"
                        [currentPage]="this.donatedToRecipientsPage" [pageSize]="this.donatedToRecipientsPageSize" [maxPagesDisplayed]="7"
                        [customPageSizes]="this.donatedToRecipientsCustomPageSizes"
                        (pageChange)="changePageResultsDonatedToRecipients($event)" #donatedtorecipientspaginator
    ></app-st-pagination2>
    <br>
    <app-st-select [idVal]="'donated-to-recipients-tax-year-list-id'" [defaultOption]="'Select Tax Year'" [label]="''" [idKey]="'taxYear'" [displayKey]="'taxYear'" [valueKey]="'taxYear'" [inputArray]="this.donatedToRecipientsTaxYears"></app-st-select>
    <br>
    <!--The Donor donated to these recipients-->
    <table class="table table-striped webtext-black" *ngIf="!this.donatedToRecipientsLoadingIcon; else loadingPageDonatedToRecipients">
      <thead>
      <tr>
        <th scope="col">Recipient of Grant
          <app-st-button-sort-text-asc *ngIf="this.sortedAscRecipientOfGrant" [idVal]="'sort-recipient-of-grant-asc-button-id'" [label]="''" [primary]="false" (click)="this.sortTextRecipientOfGrantName()">

          </app-st-button-sort-text-asc>
          <app-st-button-sort-text-desc *ngIf="!this.sortedAscRecipientOfGrant" [idVal]="'sort-recipient-of-grant-desc-button-id'" [label]="''" [primary]="false" (click)="this.sortTextRecipientOfGrantName()">

          </app-st-button-sort-text-desc>
        </th>
        <th scope="col">City
          <app-st-button-sort-text-asc *ngIf="this.sortedAscCity" [idVal]="'sort-city-asc-button-id'" [label]="''" [primary]="false" (click)="this.sortTextCity()">

          </app-st-button-sort-text-asc>
          <app-st-button-sort-text-desc *ngIf="!this.sortedAscCity" [idVal]="'sort-city-desc-button-id'" [label]="''" [primary]="false" (click)="this.sortTextCity()">

          </app-st-button-sort-text-desc>
        </th>
        <th scope="col">State
          <app-st-button-sort-text-asc *ngIf="this.sortedAscState" [idVal]="'sort-state-asc-button-id'" [label]="''" [primary]="false" (click)="this.sortTextState()">

          </app-st-button-sort-text-asc>
          <app-st-button-sort-text-desc *ngIf="!this.sortedAscState" [idVal]="'sort-state-desc-button-id'" [label]="''" [primary]="false" (click)="this.sortTextState()">

          </app-st-button-sort-text-desc>
        </th>
        <th scope="col">Country</th>
        <th scope="col">Grant Amount
          <app-st-button-sort-number-asc *ngIf="this.sortedAscCashGrantAmt" [idVal]="'sort-cash-grant-amt-asc-button-id'" [label]="''" [primary]="false" (click)="this.sortNumberCashGrantAmt()">

          </app-st-button-sort-number-asc>
          <app-st-button-sort-number-desc *ngIf="!this.sortedAscCashGrantAmt" [idVal]="'sort-cash-grant-amt-desc-button-id'" [label]="''" [primary]="false" (click)="this.sortNumberCashGrantAmt()">

          </app-st-button-sort-number-desc>
        </th>
        <th scope="col">Purpose</th>
      </tr>
      </thead>
      <tbody>
      <tr *ngIf="donorRecipientMappingRows.length == 0">
        <td colspan="6">No data found for this year.</td>
      </tr>
      <tr *ngFor="let row of donorRecipientMappingRows">
        <td>{{row['recipientOfGrantName']}}<i class="bi bi-search btn" (click)="onViewRecipientDetails(row)"></i></td>
        <td>{{row['recipientOfGrantCity']}}</td>
        <td>{{row['recipientOfGrantState']}}</td>
        <td>{{row['recipientOfGrantCountry']}}</td>
        <td>{{row['cashGrantAmtFormatted']}}</td>
        <td>{{row['purposeOfGrant']}}</td>
      </tr>
      </tbody>
    </table>
    <br>
    <ng-template #loadingPageDonatedToRecipients >
      <div class="d-flex justify-content-center">
        <br>
        <br>
        <div class="spinner-grow text-info" role="status">
          <span class="visually-hidden webtext-black">Loading...</span>
        </div>
      </div>
    </ng-template>

    <div *ngIf="(otherGrantsDtos.length > 0)" id="other-grants-donated-id" >
      <app-st-header-title [inputVal]="'Other Grants Donated to Recipients for ' + this.donatedToRecipientsTaxYear"></app-st-header-title>
      <table class="table table-striped webtext-black">
        <thead>
        <tr>
          <th scope="col">Recipient of Grant</th>
          <th scope="col">City</th>
          <th scope="col">State</th>
          <th scope="col">Country</th>
          <th scope="col">Grant Amount</th>
          <th scope="col">Purpose</th>
        </tr>
        </thead>
        <tbody>
        <tr *ngFor="let row of otherGrantsDtos">
          <td>{{row['recipientOfGrantName']}}</td>
          <td>{{row['recipientOfGrantCity']}}</td>
          <td>{{row['recipientOfGrantState']}}</td>
          <td>{{row['recipientOfGrantCountry']}}</td>
          <td>{{row['cashGrantAmtFormatted']}}</td>
          <td>{{row['purposeOfGrant']}}</td>
        </tr>
        </tbody>
      </table>
      <br><br>
    </div>
    <div *ngIf="(miscGrantsDtos.length > 0)" id="grants-donated-to-individuals-id">
      <app-st-header-title [inputVal]="'Grants Donated to Individuals for ' + this.donatedToRecipientsTaxYear"></app-st-header-title>
      <br>
      <table class="table table-striped webtext-black">
        <thead>
        <tr>
          <th scope="col">Grant Type Description</th>
          <th scope="col">Cash Grant Amount</th>
          <th scope="col">Noncash Assistance Description</th>
          <th scope="col">Noncash Assistance Amount</th>
        </tr>
        </thead>
        <tbody>
        <tr *ngFor="let row of miscGrantsDtos">
          <td>{{row['grantTypeTxt']}}</td>
          <td>{{row['cashGrantAmtFormatted']}}</td>
          <td>{{row['noncashAssistanceDesc']}}</td>
          <td>{{row['noncashAssistanceAmtFormatted']}}</td>
        </tr>
        </tbody>
      </table>
      <br><br>
    </div>
    <br>
    <app-st-button-back-to-top></app-st-button-back-to-top>
    <br>
    <br>
    <div id="grants-received-div-id" >
        <app-st-header-title [idVal]="'grants-received-id'" [inputVal]="'Grants Received by the Organization for ' + this.receivedGrantsTaxYear"></app-st-header-title>
        <br>
        <app-st-pagination2 [idVal]="'received-grants-pagination-id'" [collectionSize]="this.receivedGrantsCollectionSize"
                            [currentPage]="this.receivedGrantsPage" [pageSize]="this.receivedGrantsPageSize" [maxPagesDisplayed]="7"
                            [customPageSizes]="this.receivedGrantsCustomPageSizes"
                            (pageChange)="changePageResultsReceivedGrants($event)" #receivedgrantspaginator
        ></app-st-pagination2>
        <br>
        <app-st-select [idVal]="'received-grants-tax-year-list-id'" [defaultOption]="'Select Tax Year'" [label]="''" [idKey]="'taxYear'" [displayKey]="'taxYear'" [valueKey]="'taxYear'" [inputArray]="this.receivedGrantsTaxYears"></app-st-select>
        <br>
        <!--Other donors awarded grants to this donor / nonprofit-->
        <table class="table table-striped webtext-black" *ngIf="!this.receivedGrantsLoadingIcon; else loadingPageReceivedGrants">
          <thead>
          <tr>
            <th scope="col">Donor Name
              <app-st-button-sort-text-asc *ngIf="this.sortedAscReceivedDonor" [idVal]="'sort-received-donor-asc-button-id'" [label]="''" [primary]="false" (click)="this.sortTextReceivedDonorName()">

              </app-st-button-sort-text-asc>
              <app-st-button-sort-text-desc *ngIf="!this.sortedAscReceivedDonor" [idVal]="'sort-received-donor-desc-button-id'" [label]="''" [primary]="false" (click)="this.sortTextReceivedDonorName()">

              </app-st-button-sort-text-desc>
            </th>
            <th scope="col">Recipient of Grant
              <app-st-button-sort-text-asc *ngIf="this.sortedAscReceivedRecipientOfGrant" [idVal]="'sort-received-recipient-of-grant-asc-button-id'" [label]="''" [primary]="false" (click)="this.sortTextReceivedRecipientOfGrantName()">

              </app-st-button-sort-text-asc>
              <app-st-button-sort-text-desc *ngIf="!this.sortedAscReceivedRecipientOfGrant" [idVal]="'sort-received-recipient-of-grant-desc-button-id'" [label]="''" [primary]="false" (click)="this.sortTextReceivedRecipientOfGrantName()">

              </app-st-button-sort-text-desc>
            </th>
            <th scope="col">City
              <app-st-button-sort-text-asc *ngIf="this.sortedAscReceivedCity" [idVal]="'sort-received-city-asc-button-id'" [label]="''" [primary]="false" (click)="this.sortTextReceivedCity()">

              </app-st-button-sort-text-asc>
              <app-st-button-sort-text-desc *ngIf="!this.sortedAscReceivedCity" [idVal]="'sort-received-city-desc-button-id'" [label]="''" [primary]="false" (click)="this.sortTextReceivedCity()">

              </app-st-button-sort-text-desc>
            </th>
            <th scope="col">State
              <app-st-button-sort-text-asc *ngIf="this.sortedAscReceivedState" [idVal]="'sort-received-state-asc-button-id'" [label]="''" [primary]="false" (click)="this.sortTextReceivedState()">

              </app-st-button-sort-text-asc>
              <app-st-button-sort-text-desc *ngIf="!this.sortedAscReceivedState" [idVal]="'sort-received-state-desc-button-id'" [label]="''" [primary]="false" (click)="this.sortTextReceivedState()">

              </app-st-button-sort-text-desc>
            </th>
            <th scope="col">Country</th>

            <!--<th scope="col">Causes</th>-->
            <th scope="col">Grant Amount
              <app-st-button-sort-number-asc *ngIf="this.sortedAscReceivedCashGrantAmt" [idVal]="'sort-received-cash-grant-amt-asc-button-id'" [label]="''" [primary]="false" (click)="this.sortNumberReceivedCashGrantAmt()">

              </app-st-button-sort-number-asc>
              <app-st-button-sort-number-desc *ngIf="!this.sortedAscReceivedCashGrantAmt" [idVal]="'sort-received-cash-grant-amt-desc-button-id'" [label]="''" [primary]="false" (click)="this.sortNumberReceivedCashGrantAmt()">

              </app-st-button-sort-number-desc>
            </th>
            <th scope="col">Purpose</th>
          </tr>
          </thead>
          <tbody>
          <tr *ngIf="recievedDonorRecipientMappingRows.length == 0">
            <td colspan="7">No data found for this year.</td>
          </tr>
          <tr *ngFor="let row of recievedDonorRecipientMappingRows">
            <td>{{row['donorName']}}<i class="bi bi-search btn" (click)="onViewDonorDetails(row)"></i></td>
            <td>{{row['recipientOfGrantName']}}</td>
            <td>{{row['recipientOfGrantCity']}}</td>
            <td>{{row['recipientOfGrantState']}}</td>
            <td>{{row['recipientOfGrantCountry']}}</td>
            <td>{{row['cashGrantAmtFormatted']}}</td>
            <td>{{row['purposeOfGrant']}}</td>
          </tr>
          </tbody>
        </table>
      <ng-template #loadingPageReceivedGrants >
        <div class="d-flex justify-content-center">
          <br>
          <br>
          <div class="spinner-grow text-info" role="status">
            <span class="visually-hidden webtext-black">Loading...</span>
          </div>
        </div>
      </ng-template>
    </div>
    <br>
    <app-st-button-back-to-top></app-st-button-back-to-top>
    <br>
    <div class="col2 d-grid gap-2 d-md-flex justify-content-md-end align-items-end">
      <app-st-button [idVal]="'bottom-back-button-id'" [label]="'Back'" [primary]="true"
                     (click)="this.onBack()"></app-st-button>
      <app-st-button-pdf [idVal]="'bottom-export-pdf-button-id'" [label]="'Export As PDF'"
                     (click)="this.generateSearchablePdf()"></app-st-button-pdf>
    </div>
  </div>
</div>
<br>
